import styled from 'styled-components';

export const PageContainer = styled.main`
	padding: 24px;
	max-width: 800px;
	margin: 0 auto;
	min-height: calc(100vh - 80px);
`;

export const Title = styled.h1`
	text-align: center;
	margin-bottom: 8px;
`;

export const LoadingContainer = styled.div`
	text-align: center;
	padding: 20px;
`;

export const ErrorBox = styled.div`
	background: linear-gradient(135deg, #ffeaea 0%, #fff5f5 100%);
	border: 1px solid #f44336;
	border-radius: 12px;
	padding: 12px;
	color: #c62828;
	margin-bottom: 16px;
	text-align: center;
`;

export const EmptyContainer = styled.div`
	text-align: center;
	padding: 20px;
`;

export const EmptyPrompt = styled.p`
	margin-top: 8px;
`;

export const EntriesGrid = styled.div`
	display: grid;
	gap: 16px;
	padding-bottom: 24px;
`;

export const EntryCard = styled.div`
	padding: 16px;
	position: relative;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	border-radius: 16px;
	background: #fff;
`;

export const DeleteButton = styled.button<{ disabled?: boolean }>`
	position: absolute;
	top: 12px;
	right: 12px;
	background: none;
	border: none;
	cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
	padding: 8px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: ${props => (props.disabled ? 0.5 : 0.7)};
	transition: opacity 0.2s;

	&:hover {
		opacity: ${props => (props.disabled ? 0.5 : 1)};
		background-color: ${props => (props.disabled ? 'transparent' : '#fee')};
	}

	span {
		font-size: 16px;
	}
`;

export const DeleteIcon = styled.span`
	color: #999;
`;

export const EntryHeader = styled.div`
	margin-bottom: 12px;
	padding-right: 40px;
`;

export const EntryDate = styled.p`
	font-size: 14px;
	color: #666;
`;

export const EntryEmotion = styled.p`
	font-size: 18px;
	margin-top: 4px;
`;

export const CorrectionText = styled.span`
	color: #666;
	font-size: 14px;
	margin-left: 8px;
`;

export const EntrySummary = styled.p`
	margin-bottom: 12px;
	white-space: pre-wrap;
`;

export const ImagesSection = styled.div`
	margin-bottom: 12px;
`;

export const ImagesSectionTitle = styled.p`
	font-size: 14px;
	margin-bottom: 8px;
	color: #666;
`;

export const ImagesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
	gap: 8px;
`;

export const ImageContainer = styled.div`
	text-align: center;
`;

export const CapturedImage = styled.img`
	width: 120px;
	height: 80px;
	object-fit: cover;
	border-radius: 8px;
`;

export const ImagePlaceholder = styled.div`
	width: 120px;
	height: 80px;
	background-color: #f3f4f6;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: #6b7280;
`;

export const ImageEmotion = styled.p`
	font-size: 12px;
	color: #666;
	margin-top: 4px;
`;

export const NotesLabel = styled.label`
	display: block;
`;

export const NotesTitle = styled.p`
	font-size: 14px;
	margin-bottom: 4px;
	color: #666;
`;

export const NotesTextarea = styled.textarea`
	width: 100%;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	padding: 8px;
	resize: vertical;
	font-size: 14px;
`;

export const DialogOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const DialogContent = styled.div`
	background-color: white;
	border-radius: 12px;
	padding: 24px;
	margin: 20px;
	max-width: 400px;
	width: 100%;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const DialogTitle = styled.h3`
	margin-bottom: 12px;
	text-align: center;
`;

export const DialogMessage = styled.p`
	margin-bottom: 20px;
	text-align: center;
	color: #666;
`;

export const DialogButtons = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
`;

export const DialogButton = styled.div`
	min-width: 100px;
`;
